import { Timeline, Text, Group, Loader, Center, Flex } from '@mantine/core';
import { DATE_FORMAT, formatDate } from '../../../helper';
import { useTranslation } from 'react-i18next';
import { SupplierRiskAssessmentHistory } from '../../../hooks';
import { getInitials } from '../../../helper/data-transform';
import { BetaIcon } from '../../../../lib/components';

type RiskAssessmentHistoryProps = {
  riskHistory: SupplierRiskAssessmentHistory[] | undefined;
  loading: boolean;
};

const RiskAssessmentHistory = ({
  riskHistory,
  loading,
}: RiskAssessmentHistoryProps) => {
  const { t } = useTranslation();

  if (loading)
    return (
      <Center h={200}>
        <Loader />
      </Center>
    );

  if (!riskHistory?.length)
    return (
      <Flex h={200} direction="column" align="center" justify="center" gap="xs">
        <BetaIcon icon="calendar" />
        <Text>{t('suppliers.riskAssessment.activities.empty')}</Text>
      </Flex>
    );

  return (
    <Timeline
      active={riskHistory.length}
      bulletSize={24}
      style={{ marginTop: 16 }}
    >
      {[...riskHistory].reverse().map((risk: SupplierRiskAssessmentHistory) => {
        const status = risk?.status || risk.afterData.status;
        const statusLabel = t(`suppliers.riskAssessment.status.${status}`);

        const updatedByLabel = `${t(
          'suppliers.riskAssessment.activities.updatedBy'
        )} ${risk?.updatedBy}`;

        return (
          <Timeline.Item
            key={risk?.updatedAt}
            bullet={
              <Text size="sm" title={updatedByLabel} lh={1.5}>
                {getInitials(risk?.updatedBy)}
              </Text>
            }
            title={
              <Group justify="space-between">
                <Text size="lg" truncate maw={170} title={statusLabel}>
                  {statusLabel}
                </Text>
                <Text
                  size="xs"
                  c="dark.4"
                  title={formatDate(risk.updatedAt, `${DATE_FORMAT} HH:mm`)}
                >
                  {formatDate(risk.updatedAt)}
                </Text>
              </Group>
            }
          >
            {risk?.notes && (
              <>
                <Text c="dark.4">
                  {t('suppliers.riskAssessment.activities.notes')}
                </Text>
                <Text>{risk?.notes}</Text>
              </>
            )}
          </Timeline.Item>
        );
      })}
    </Timeline>
  );
};

export default RiskAssessmentHistory;
